export default `
<div class="text--center">
    <h1 class="push--bottom">No Results Found</h1>
    <p>Please try a different search query</p>
</div>
`;

